module.exports = __webpack_public_path__ + "static/media/krypdyr.4aa4c6b7.m4a";